<div class="virtual-queue">
    <section *ngFor="let section of data">
        <h4 *ngIf="section.title" class="title">{{section.title}}</h4>
        <div class="content dynamic-html" [innerHtml]="section.text | safeHtml"></div>
    </section>
</div>
